var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: { "max-width": "520", "retain-focus": false, persistent: "" },
      model: {
        value: _vm.dialog,
        callback: function ($$v) {
          _vm.dialog = $$v
        },
        expression: "dialog",
      },
    },
    [
      _c("v-card", { staticClass: "primary p-4" }, [
        _c(
          "div",
          {
            staticClass:
              "navy--text text--darken-1 pt-2 px-2 d-flex align-center font-hemi-head",
          },
          [
            _c("v-icon", { staticClass: "white--text", attrs: { left: "" } }, [
              _vm._v("auto_awesome"),
            ]),
            _vm._v(" "),
            _c(
              "span",
              {
                staticClass: "white--text",
                staticStyle: { "font-size": "18px" },
              },
              [_vm._v("\n        SCEGLI STRATEGIA\n      ")]
            ),
            _vm._v(" "),
            _c("v-spacer"),
            _vm._v(" "),
            _c(
              "v-btn",
              {
                attrs: { depressed: "", icon: "" },
                on: {
                  click: function ($event) {
                    return _vm.dismiss()
                  },
                },
              },
              [_c("v-icon", [_vm._v("close")])],
              1
            ),
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "navy darken-1 white--text pa-4" },
          [
            _c("div", [
              _vm._v(
                "\n        Scegli lo schema che vorresti utilizzare e Asta Live distribuirà i\n        crediti tra i vari slot in modo coerente con quella strategia.\n      "
              ),
            ]),
            _vm._v(" "),
            _c(
              "v-alert",
              {
                staticClass: "mt-4 mb-0",
                attrs: { dense: "", text: "", type: "warning" },
              },
              [
                _vm._v(
                  "\n        Se avevi già pianificato i crediti, verranno sovrascritti.\n      "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "py-4" },
              [
                _c("v-select", {
                  attrs: {
                    items: _vm.strategieOptions,
                    label: "Scegli schema",
                    solo: "",
                    flat: "",
                    "hide-details": "",
                  },
                  model: {
                    value: _vm.strategiaModel,
                    callback: function ($$v) {
                      _vm.strategiaModel = $$v
                    },
                    expression: "strategiaModel",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _vm.strategiaPreview
              ? _c(
                  "div",
                  { staticClass: "strategia-preview mb-4" },
                  [
                    _c("div", { staticClass: "font-hemi-head mb-2" }, [
                      _vm._v("ANTEPRIMA DISTRIBUZIONE CREDITI"),
                    ]),
                    _vm._v(" "),
                    _vm._l(_vm.strategiaPreview, function (ruoloPreview) {
                      return _c(
                        "div",
                        {
                          key: ruoloPreview.ruolo_abc,
                          staticClass: "strategia-preview-ruolo mb-2",
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-center mb-1" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "strategia-preview-ruolo-dot mr-2",
                                  class: "ruolo_" + ruoloPreview.ruolo_id,
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(ruoloPreview.ruolo_abc) +
                                      "\n            "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c("crediti", {
                                attrs: {
                                  crediti: ruoloPreview.totale,
                                  variant: "dark",
                                },
                              }),
                              _vm._v(" "),
                              _c("div", { staticClass: "ml-2 text-caption" }, [
                                _vm._v(
                                  "\n              " +
                                    _vm._s(ruoloPreview.percentuale) +
                                    "%\n            "
                                ),
                              ]),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "strategia-preview-slots" },
                            _vm._l(ruoloPreview.slots, function (slotPreview) {
                              return _c(
                                "span",
                                {
                                  key:
                                    ruoloPreview.ruolo_abc + slotPreview.slot,
                                  staticClass: "strategia-preview-slot",
                                },
                                [
                                  _c("crediti", {
                                    attrs: { crediti: slotPreview.crediti },
                                  }),
                                ],
                                1
                              )
                            }),
                            0
                          ),
                        ]
                      )
                    }),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "text-right font-weight-bold pt-1" },
                      [
                        _vm._v(
                          "\n          Totale: " +
                            _vm._s(_vm.strategiaPreviewTotale) +
                            " / " +
                            _vm._s(_vm.asta_info.lega.crediti) +
                            "\n        "
                        ),
                      ]
                    ),
                  ],
                  2
                )
              : _vm._e(),
            _vm._v(" "),
            _vm.strategiaModel
              ? _c(
                  "v-alert",
                  {
                    staticClass: "mb-4",
                    attrs: { dense: "", text: "", type: "info" },
                  },
                  [
                    _vm._v(
                      "\n        Ricorda che potrai sempre modificarli a mano dopo\n      "
                    ),
                  ]
                )
              : _vm._e(),
            _vm._v(" "),
            _c(
              "v-card-actions",
              { staticClass: "justify-center pa-0" },
              [
                _c(
                  "v-btn",
                  {
                    staticClass: "secondary",
                    attrs: { rounded: "", disabled: !_vm.strategiaModel },
                    on: { click: _vm.saveStrategia },
                  },
                  [_vm._v("\n          Salva\n        ")]
                ),
                _vm._v(" "),
                _c(
                  "v-btn",
                  {
                    staticClass: "secondary--text",
                    attrs: { rounded: "", outlined: "" },
                    on: { click: _vm.dismiss },
                  },
                  [_vm._v("\n          Annulla\n        ")]
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }